import styled from "styled-components";

export const Container = styled.main`
    max-width: 1020px;
    margin: 0 auto;
    padding: 2.5rem 1rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;